import {deleteRequest, getRequest, postRequest, putRequest} from "../../httpClient";


export async function loadUsersForGroup(token, group) {
    return await getRequest(`/v3/users/group/${group}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function loadUserGroups(token, username) {
    return await getRequest(`/v3/users/groups/${username}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function searchUsersByFilter(token, body) {
    return await postRequest(`/v3/users/search`, token, body)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}


export async function loadIAMGroups(token) {
    return await getRequest(`/v3/groups`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}




export async function addUserToIamGroup(token, body) {
    return await putRequest(`/v3/users/group`, token, body)
        .then(resp => {
            if (resp.ok) {
                return resp;
            }
            throw resp
        })
        .catch(err => err);
}


export async function removeUserFromIamGroup(token, body) {
    return await deleteRequest(`/v3/users/group`, token, body)
        .then(resp => {
            if (resp.ok) {
                return resp;
            }
            throw resp
        })
        .catch(err => err);
}
